export default "__VITE_ASSET__Tr2yO7Rm__"